import { LoadingButton } from '@mui/lab';
import { Autocomplete, Box, Button, CircularProgress, TextField } from '@mui/material';
import { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Proptypes from 'prop-types';

import { api as stockApi } from '../../store/domains/stock';
import { useAutoCompleteState } from '../../hooks/useAutoCompleteState';
import { transferResponseHandler } from '../../utils/transferResponse';
import Render from '../Render';

const StartPackFileUpload = ({ handleClose, hubId, isTransfer }) => {
  const [fileUploadMutation, { isLoading }] = stockApi.usePostAssignStartPackWithFile();
  const [fileUploadTransferMutation, { isLoading: isLoadingTransfer }] =
    stockApi.usePostAssignStartPackWithFileTransfer();

  const { data: posManagerOrganizations, isLoading: posManagerLoading } = stockApi.useGetPosManagerOrganizations(
    hubId,
    {
      skip: !hubId,
    }
  );
  const { data: posManagerPartners, isLoading: posManagerOrganizationsLoading } = stockApi.useGetOrganizations(null, {
    skip: !isTransfer,
  });
  const [partnerId, handleChange] = useAutoCompleteState();
  const [toPartner, handleChangeToPartner] = useAutoCompleteState();
  const [file, setFile] = useState();

  function handleChangeForm(event) {
    setFile(event.target.files[0]);
  }

  const onSubmit = () => {
    const form = new FormData();
    form.append('file', file);
    form.append(
      'transferData',
      JSON.stringify({
        fromPartner: partnerId,
        toPartner,
      })
    );
    if (isTransfer) {
      fileUploadTransferMutation(form)
        .unwrap()
        .then(transferResponseHandler)
        .finally(() => {
          handleClose();
        });
      return;
    }

    const data = {
      form,
      partnerId,
    };
    fileUploadMutation(data)
      .unwrap()
      .finally(() => {
        handleClose();
      });
  };
  if (posManagerLoading || posManagerOrganizationsLoading) {
    return <CircularProgress />;
  }

  return (
    <Box paddingTop={4}>
      <Autocomplete
        value={partnerId}
        onChange={handleChange}
        options={posManagerOrganizations || []}
        renderInput={(params) => <TextField {...params} label="Select Partner" />}
        fullWidth
      />
      <Render shouldRender={isTransfer}>
        <Autocomplete
          value={toPartner}
          onChange={handleChangeToPartner}
          options={posManagerPartners || []}
          renderInput={(params) => <TextField {...params} label="Select Partner to transfer" />}
          fullWidth
          sx={{ mt: 2 }}
        />
      </Render>
      <Box display="flex" alignItems="center">
        <Button
          sx={{
            marginTop: 3,
          }}
          variant="contained"
          component="label"
        >
          Upload File
          <input onChange={handleChangeForm} type="file" hidden />
        </Button>
        {file && (
          <Box display="flex" alignItems="center" marginLeft={4}>
            {file.name}
            <CheckCircleOutlineIcon sx={{ marginLeft: 1 }} color="success" />
          </Box>
        )}
      </Box>

      <LoadingButton
        loading={isLoading || isLoadingTransfer}
        disabled={isLoading || !file || !partnerId || isLoadingTransfer}
        onClick={onSubmit}
        sx={{ my: 2 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

StartPackFileUpload.propTypes = {
  handleClose: Proptypes.func,
  hubId: Proptypes.number,
  isTransfer: Proptypes.bool,
};
export default StartPackFileUpload;
